import { render, staticRenderFns } from "./quotationLastMileDetail.vue?vue&type=template&id=2af85c72&scoped=true&"
import script from "./quotationLastMileDetail.vue?vue&type=script&lang=js&"
export * from "./quotationLastMileDetail.vue?vue&type=script&lang=js&"
import style0 from "./quotationLastMileDetail.vue?vue&type=style&index=0&id=2af85c72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af85c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af85c72')) {
      api.createRecord('2af85c72', component.options)
    } else {
      api.reload('2af85c72', component.options)
    }
    module.hot.accept("./quotationLastMileDetail.vue?vue&type=template&id=2af85c72&scoped=true&", function () {
      api.rerender('2af85c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Quotation/quotationLastMileDetail.vue"
export default component.exports